module.exports = __webpack_public_path__ + "img/Logo.9ee91492.png";